import React from "react";
import "./index.css";

const Loader = () => {
  return (
    <div class="loader-main">
      <span class="loader"></span>
    </div>
  );
};

export default Loader;
